<template>
    <div class="category-view relative bg-theme-gray w-full flex h-auto">
        <CategoryList :list="state"></CategoryList>
        <div class="w-[calc(100%-16rem)] pb-40 h-auto pt-0 item-body">
            <div class="information">
                <section class="ml-20 my-6">
                    <p class="text-sm text-txt-lightgray ml-4"><router-link class="hover:underline"
                            to="/">HOME</router-link> >
                        <span class="text-txt-gray">{{ category_name }}</span>
                    </p>
                </section>
                <!-- Category注記文 -->
                <section>
                    <p class="cautionword my-6 text-txt-gray">※表示価格はスマート介護カタロ<br>グ掲載価格です。<br><br>※商品名に■マークがある商品は<br>イチオシ家具カタログ掲載品です。
                    </p>
                </section>
                <!-- Category注記文ここまで -->
            </div>
            <section class="flex flex-wrap ml-20">
                <article v-for="item in state.items" :key="item.id" class="bg-theme-white w-96 h-60 ml-4 mb-4 relative">

                    <!--<article v-for="(product, key, index) in state.item" :key="index" class="flex bg-theme-white w-96 h-60 ml-4 mb-4">-->
                    <!--<p>{{ key }} is {{ product }}</p>-->
                    <router-link class="flex h-full hover:opacity-70 transition uration-300" @click="handleClick"
                        :to="{ name: 'Group', query: { operationtype: 'group', webcat_view: item.webcat_view, cassette_id: item.cassette_id } }">
                        <SoldOut class="" v-if="item.sold_out_block == '1'"></SoldOut>
                        <div class="w-2/5 flex justify-center items-center">
                            <img class="w-11/12" :src="item.cassette_img01">
                        </div>
                        <div class="w-3/5 flex flex-col justify-evenly p-3">
                            <div class="name">
                                <h1 class="text-lg font-bold">{{ item.cassette_block_name }}</h1>
                                <p class="text-xs"><span>メーカー：</span>{{ item.maker_name }}</p>
                            </div>
                            <div class="price w-max">
                                <p class="text-xs text-txt-red">税抜</p>
                                <p class="text-2xl text-txt-red">
                                    <span>¥</span>
                                    {{ item.cassette_price_off }}
                                </p>
                                <p class="text-xs text-right text-txt-red"><span>（税込¥</span> {{ item.cassette_price_on }}）
                                </p>
                            </div>
                            <div class="comment-area">
                                <p class="text-xs">{{ item.cassette_comment01 }}</p>
                            </div>
                        </div>
                    </router-link>
                </article>
            </section>
            <section class="ml-20 my-6">
                <p class="text-sm text-txt-lightgray ml-4"><router-link class="hover:underline" to="/">HOME</router-link> >
                    <span class="text-txt-gray">{{ category_name }}</span>
                </p>
            </section>
        </div>
    </div>
    <Footer></Footer>
</template>



<script>

// import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { ref, watchEffect, reactive, onMounted } from 'vue';
import CategoryList from '@/components/CategoryList.vue';
import SoldOut from '@/components/kanbai.vue';
import Footer from '@/components/Footer.vue';
import { search_json } from '@/json.config.js';
import axios from 'axios'

export default {
    components: {
        SoldOut,
        CategoryList,
        Footer
    },
    name: 'categoryview',
    methods: {
        handleClick: function () {
            window.scroll({ top: 0, behavior: 'smooth' });
        }
    },
    setup() {
        const route = useRoute()
        const category_param = ref(route.query.webcat_view)

        let url = ref('')
        const category_items = ref([])
        const state = reactive({
            // num:null,
            data: null,
            items: null
            // rates:{},
            // result:computed(() => state.num * state.rates.JPY),
        })

        let category_name = ref('')
        watchEffect(() => {
            // const router = useRouter()
            category_param.value = route.query.webcat_view
            category_items.value = []

            switch (category_param.value) {
                case 'Outlet':
                    category_name.value = 'アウトレット'
                    break
                // case 'Prevention':
                //     category_name.value = '感染対策用品'
                //     break
                case 'Accessory':
                    category_name.value = 'アクセサリー'
                    break
                case 'Desk':
                    category_name.value = 'デスク・デスク周辺'
                    break
                case 'Table':
                    category_name.value = 'テーブル'
                    break
                case 'Chair':
                    category_name.value = 'チェア'
                    break
                case 'Lobby':
                    category_name.value = '応接・ロビー'
                    break
                case 'MeetingChair':
                    category_name.value = 'ミーティングチェア'
                    break
                case 'Partition':
                    category_name.value = 'パーティション'
                    break
                case 'Board':
                    category_name.value = 'ボード'
                    break
                case 'Storage':
                    category_name.value = '収納'
                    break
                case 'Counter':
                    category_name.value = 'カウンター'
                    break
                // case 'Emergency':
                //     category_name.value = '防災用品'
                //     break
                case 'Education':
                    category_name.value = '教育・保育施設'
                    break
                case 'Medical':
                    category_name.value = '医療・福祉施設'
                    break
                default:
                    category_name.value = ''
                    break
            }

            //タイトル変更
            document.title = category_name.value + "｜イチオシ";


            url = "https://666wcb198b.execute-api.ap-northeast-1.amazonaws.com/resource/query?operationtype=category&webcat_view=" + category_param.value;
            // console.log(url)

            // const search_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search2023_so.json"
            async function getitems() {
                // state.data = await axios.get(url)
                const all_data = await axios.get(search_json)
                // console.log(all_data)
                all_data.data.forEach(function (value) {
                    if (value.webcat_view === category_param.value) {
                        category_items.value.push(value)
                    }
                })

                // console.log(category_item.value)
                // state.items = 
                state.items = []
                // for(var i=0;i < state.data.data.Items.length;i++){
                for (var i = 0; i < category_items.value.length; i++) {
                    var val = category_items.value[i];
                    // console.log(val)
                    const group_id = val.cassette_id.split("_")[0];//グループを格納する変数
                    // state.items = group_id;
                    // console.log(state.items[0]["group_id"]);
                    // if(state.items["group_id"] == group_id){
                    //     console.log("同じ項目です");
                    // }

                    // 税込価格の表示のやつ


                    let price_on = String(val.cassette_price_on)
                    let check_letter_on = price_on.indexOf("～")
                    if (check_letter_on == -1) {
                        price_on = price_on.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        // console.log(price_on)
                    } else {
                        price_on = price_on.substring(0, price_on.length - 1)
                        price_on = price_on.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        price_on = price_on + "～"
                        // console.log(price_on)
                    }

                    // 税抜価格の表示のやつ
                    let price_off = String(val.cassette_price_off)
                    let check_letter_off = price_on.indexOf("～")
                    if (check_letter_off == -1) {
                        price_off = price_off.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        // console.log(price_on)
                    } else {
                        price_off = price_off.substring(0, price_off.length - 1)
                        price_off = price_off.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        price_off = price_off + "～"
                        // console.log(price_off)
                    }

                    const item_val = {
                        [group_id]: {
                            cassette_id: val.cassette_id.split("_")[0],
                            webcat_view: val.webcat_view,
                            cassette_block_name: val.cassette_block_name,
                            maker_name: val.maker_name,
                            cassette_img01: "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/" + val.cassette_img01,
                            sold_out_block: val.sold_out_block,
                            cassette_comment01: val.cassette_comment01,
                            // cassette_price_on:parseInt(val.cassette_price_on, 10),
                            // cassette_price_off:parseInt(val.cassette_price_off,10)
                            cassette_price_on: price_on,
                            cassette_price_off: price_off
                        }
                    }



                    // state.items.push(item_val);
                    state.items = Object.assign(state.items, item_val);

                    // // state.items = [group_id:{"aa":"bb"}];

                    // const result1 = Object.assign(state.items, {"group_id":group_id,"aa":"bb"});

                    // console.log(group_id);
                    // console.log(val.cassette_id.split("_")[0]);
                }
                state.items = Object.values(state.items);
                // console.dir(state.items);
            }

            getitems()
        })

        // const router = useRouter()
        const aaa = onMounted(() => {
            window.addEventListener("beforeunload", function () {
                window.location = "/"
                console.log("ok")
            })
            // beforeEnter() {
            //   window.location = "https://www.example.com/top"
            // }
        })
        return {
            // products,
            category_param,
            category_name,
            watchEffect,
            state,
            url,
            aaa
        }

    }
}



</script>

